import { render, staticRenderFns } from "./Server.vue?vue&type=template&id=60a19f33&scoped=true&"
import script from "./Server.vue?vue&type=script&lang=ts&"
export * from "./Server.vue?vue&type=script&lang=ts&"
import style0 from "./Server.vue?vue&type=style&index=0&id=60a19f33&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a19f33",
  null
  
)

export default component.exports